var exports = {
  "kL": "container__HkeWSc",
  "a6": "assistive__aYhumu",
  "jg": "emptyContent__rQZdGt",
  "BK": "messageContent__4A-Tbg",
  "i9": "scrollToBottomButton__-aIIrw",
  "R": "hidden__A_a7sr",
};

module.exports = exports;
